<div
  class="w-screen h-screen bg-slate-100 flex justify-center items-center select-none"
>
  <div class="bg-white flex flex-col h-max p-7 sm:rounded-lg w-96 border">
    <img src="/logo.png" alt="Coyote Textil Logo" class="h-16 w-auto object-contain" />

    <h1
      class="mt-4 text-center text-lg font-semibold leading-none tracking-tight"
    >
      Inicio de Sesión
    </h1>

    <form
      [formGroup]="loginForm"
      (ngSubmit)="submit()"
      class="flex flex-col gap-4 mt-4"
    >
      <div class="flex flex-col gap-2">
        <label for="username">Nombre de Usuario</label>
        <input
          type="text"
          id="username"
          formControlName="username"
          class="basic-input"
          placeholder="Escriba su nombre de usuario"
        />
      </div>

      <div>
        <label for="password" class="mt-4">Contraseña</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          class="basic-input"
          placeholder="Escriba su contraseña"
        />
      </div>

      <!-- TODO: implement remember login -->
      <!-- <div class="mt-4">
        <input type="checkbox" id="rememberLogin" class="mr-1" v-model="rememberLogin" />
        <label for="rememberLogin">Recordarme</label>
      </div> -->

      <button
        type="submit"
        class="primary normal"
        [disabled]="loginForm.invalid"
      >
        Iniciar Sesión
      </button>
    </form>

    @if (errorMessage && loginForm.pristine) {
    <span class="mt-4 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </div>
</div>
